import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION5: PdfComponent = {
  type: 'section',
  id: 'iars5',
  title: '5. Complaints and Monitoring',
  content: [
    {
      type: 'bulletList',
      id: 'iars5bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'All client complaints relating to activities under this Agreement must be referred immediately to the Principal’s Compliance Officer.',
        },
        {
          copy: 'The Principal and FCA may conduct audits or inspections. The Introducer shall:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'Permit access to premises, personnel, and records;',
              },
              {
                copy: 'Cooperate fully;',
              },
              {
                copy: "Permit similar access to the Principal's auditors in accordance with section 341 of the Act.",
              },
            ],
          },
        },
      ],
      prefix: '5',
    },
  ],
};
